import { SubstratZeile } from '../../../data-model';

/**
 * Pure helpers fuer die Grube-Profil-Logik (Substrat-Karten/-Tabelle, Komponenten-
 * agnostisch). Plain functions, damit sie ohne TestBed/DI getestet werden koennen.
 */

/**
 * Gefuege ist nur fuer bindige Boeden (Lehm/Schluff/Ton) sinnvoll.
 * KA5-Bodenart-Codes beginnen mit L/U/T fuer bindige Klassen.
 */
export function istBindigSubstrat(substrat: string | undefined): boolean {
	if (!substrat) return false;
	const c = substrat.trim().charAt(0).toLowerCase();
	return c === 'l' || c === 'u' || c === 't';
}

/** Einzeiliger Summary fuer den eingeklappten Karten-Header. */
export function summaryLineRow(row: SubstratZeile | undefined): string {
	if (!row) return '';
	const parts: string[] = [];
	if (row.substrat) parts.push(row.substrat);
	if (row.humusgehalt != null) parts.push(`h${row.humusgehalt}`);
	if (row.lagerungsdichte != null) parts.push(`Ld${row.lagerungsdichte}`);
	if (row.festigkeit != null) parts.push(`f${row.festigkeit}`);
	if (row.skelettgehalt != null) parts.push(`Sk${row.skelettgehalt}`);
	if (row.karbonatgehalt != null) parts.push(`c${row.karbonatgehalt}`);
	if (row.farbe) parts.push(row.farbe);
	if (row.schichtLage) parts.push(row.schichtLage);
	if (row.perstruktionszone) parts.push(row.perstruktionszone);
	return parts.join(' · ');
}

/** Initialisiert Sub-Objekte einer Zeile (Altzeilen oder neue). */
export function ensureSubstratRow(row: SubstratZeile | undefined): void {
	if (!row) return;
	if (!row.gefuege) row.gefuege = { form: '', groesse: '', auspraegung: '' };
	if (!row.feindurchwurzelung) row.feindurchwurzelung = { dichte: '', haeufung: 0 };
	if (!row.probeentnahme) row.probeentnahme = {};
}
